<template>
  <div v-if="user.role == 'employee'">
    <EmployeeProfile />
  </div>
  <div v-else-if="user.role == 'client'">
    <ClientProfile />
  </div>
  <div v-else-if="user.role == 'manager' || user.role == 'boh' || user.role == 'superadmin'">
    <ManagerProfile />
  </div>
  <div v-else>
    <GenericProfile />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import EmployeeProfile from '@/components/profile/employee-profile.vue'
import ClientProfile from '@/components/profile/client-profile.vue'
import ManagerProfile from '@/components/profile/manager-profile.vue'
import GenericProfile from '@/components/profile/generic-profile.vue'

export default {
  components: {
    EmployeeProfile,
    ClientProfile,
    GenericProfile,
    ManagerProfile,
  },
  computed: {
    ...mapState('userAuth', [
      'user',
    ]),
  },
  created () {
  },
  watch: {
  },
  data: function () {
    return {}
  },
  methods: {
  },
}
</script>

<style scoped>
</style>
